module.exports = __webpack_public_path__ + "static/assets/8291ddf989380c548d5888b54fce3413.png";